import readOnlyLayout from "../helpers/readOnlyLayout";

function getView() {
  return readOnlyLayout({
    model: "melhous.special_services",
    activeSearch: false,
    target: "melhous",
    domain: [],
    fields: {
      title: { type: "char" },
      icon: { type: "char" },
      image: { type: "char" },
      note: { type: "char" },
      permitted: { type: "boolean" },
      description: { type: "text" },
    },
    list: [
      { name: "title" },
      { name: "permitted" },
      { name: "description" },
    ],
    form: [
      { name: "title" },
      { name: "permitted" },
      { name: "icon" },
      { name: "image" },
      { name: "note" },
      { name: "description", colSpan: "md:col-span-2" },
    ],
  });
}

export default { ctxView: getView };
